import {Action} from '@ngrx/store';

export const IS_AUTH = 'IS_AUTH';
export const IS_AUTH_SUCCESS = 'IS_AUTH_SUCCESS';

export const LOAD_ALL_ITEM = 'LOAD_ALL_ITEM';
export const LOAD_ALL_ITEM_SUCCESS = 'LOAD_ALL_ITEM_SUCCESS';

export const LOAD_ALL_PARTY = 'LOAD_ALL_PARTY';
export const LOAD_ALL_PARTY_SUCCESS = 'LOAD_ALL_PARTY_SUCCESS';

export const LOAD_ALL_COMPANY = 'LOAD_ALL_COMPANY';
export const LOAD_ALL_COMPANY_SUCCESS = 'LOAD_ALL_COMPANY_SUCCESS';

export class IsAuth implements Action {
	readonly type = IS_AUTH;
    constructor(public payload?: any) { }
}

export class IsAuthSuccess implements Action {
	readonly type = IS_AUTH_SUCCESS;
    constructor(public payload?: any[]) { }
}


export class LoadAllItem implements Action {
	readonly type = LOAD_ALL_ITEM;
    constructor(public payload?: any) { }
}

export class LoadAllItemSuccess implements Action {
	readonly type = LOAD_ALL_ITEM_SUCCESS;
    constructor(public payload?: any[]) { }
}

export class LoadAllParty implements Action {
	readonly type = LOAD_ALL_PARTY;
    constructor(public payload?: any) { }
}

export class LoadAllPartySuccess implements Action {
	readonly type = LOAD_ALL_PARTY_SUCCESS;
    constructor(public payload?: any[]) { }
}

export class LoadAllCompany implements Action {
	readonly type = LOAD_ALL_COMPANY;
    constructor(public payload?: any) { }
}

export class LoadAllCompanySuccess implements Action {
	readonly type = LOAD_ALL_COMPANY_SUCCESS;
    constructor(public payload?: any[]) { }
}


export type All = IsAuth | IsAuthSuccess | LoadAllItem | LoadAllItemSuccess 
		| LoadAllParty | LoadAllPartySuccess | LoadAllCompany | LoadAllCompanySuccess



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/store/actions/common.actions.ts